import React from 'react';
import ChartistGraph from 'react-chartist';
import Chartist from 'chartist';
import { connect } from 'react-redux';
import { getReport } from '../../redux/mystep/mystep.actions';
import Config from '../../config/Config';

const Report = ({ getReport, isFreeTest, isReport, type, data }) => {
	const handleDownloadClick = () => {
		getReport();
	};

	let options = {
		fullWidth: true,
		lineSmooth: false,
		chartPadding: {
			right: 50,
			left: 10,
		},
		axisY: {
			type: Chartist.FixedScaleAxis,
			ticks: ['0', '2', '4', '6', '8', '10', '12'],
			// low: 1
			low: 0,
			high: 12,
		},
	};

	return (
		<div>
			<div className="accordionContent">
				<div className="row">
					<div className="col-md-12 col-sm-12 col-xs-12">
						<div className="panel panel-default panel-course-block">
							<h5 className="coursetitle">Estimated english proficiency </h5>
							<div className="progress-bar-wrapper"></div>
							{!isFreeTest ? (
								<div>
									<h5 className="coursetitle">Your last five test scores</h5>
									<div className=" ct-chart ct-major-twelfth">
										{data && options && (
											<ChartistGraph data={data} options={options} type={type} />
										)}
									</div>
								</div>
							) : (
								''
							)}
							{isReport ? (
								<div className="detailreport-download">
									<span onClick={handleDownloadClick}>
										<img
											src={Config.ASSETSPATH + 'img/detailreportdownload.png'}
											alt="detail"
										/>
										Download Detailed Report
									</span>
								</div>
							) : (
								''
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const {
		isFreeTest,
		currentLevelDesc,
		isReport,
		type,
		data,
	} = state.rootReducer.myStepDetails.report;

	return {
		isFreeTest,
		currentLevelDesc,
		isReport,
		data,
		type,
		isRetail: state.rootReducer.loginDetails.isRetail,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getReport: () => dispatch(getReport()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Report);
